import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../../../design-system/components/composite/Modal/Modal";
import { DELIVER_COPY } from "./deliverStory.copy";
import ActiveDeliveriesTable from "./ActiveDeliveriesTable";
import { SendErrorText } from "./SendNowModal.styles";
import type { Delivery } from "./types";
import {
  TitleStack,
  Title,
  Subtitle,
  CancelLink,
  FooterRow,
  PrimaryPillButton,
} from "./ActiveDeliveriesModal.styles";

export interface ActiveDeliveriesModalProps {
  open: boolean;
  onClose: () => void;
  onAddNew: () => void;
  deliveries: Delivery[];
  isLoading?: boolean;
  isError?: boolean;
  errorMessage?: string | null;
  /** Backend's actual error string from the most recent pause/resume/
   * cancel/delete action (as opposed to `errorMessage`, which is the list
   * fetch failing) — rendered above the table so it's visible without
   * replacing the rows the user is looking at. */
  actionErrorMessage?: string | null;
  onEdit?: (id: string) => void;
  onPause?: (id: string) => void;
  onResume?: (id: string) => void;
  onCancel?: (id: string) => void;
  onDelete?: (id: string) => void;
}

const ActiveDeliveriesModal: React.FC<ActiveDeliveriesModalProps> = ({
  open,
  onClose,
  onAddNew,
  deliveries,
  isLoading,
  isError,
  errorMessage,
  actionErrorMessage,
  onEdit,
  onPause,
  onResume,
  onCancel,
  onDelete,
}) => (
  <Modal open={open} onClose={onClose} size="xl">
    <ModalHeader onClose={onClose}>
      <TitleStack>
        <Title>{DELIVER_COPY.activeDeliveries}</Title>
        <Subtitle>{DELIVER_COPY.subtitle}</Subtitle>
      </TitleStack>
    </ModalHeader>

    <ModalBody>
      {actionErrorMessage && <SendErrorText>{actionErrorMessage}</SendErrorText>}
      <ActiveDeliveriesTable
        deliveries={deliveries}
        isLoading={isLoading}
        isError={isError}
        errorMessage={errorMessage}
        onEdit={onEdit}
        onPause={onPause}
        onResume={onResume}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    </ModalBody>

    <ModalFooter>
      <FooterRow>
        <CancelLink type="button" onClick={onClose}>
          {DELIVER_COPY.cancel}
        </CancelLink>
        <PrimaryPillButton variant="primary" onClick={onAddNew}>
          {DELIVER_COPY.addNew}
        </PrimaryPillButton>
      </FooterRow>
    </ModalFooter>
  </Modal>
);

export default ActiveDeliveriesModal;
